module.exports = __webpack_public_path__ + "assets/payments-white.52bce7f0.svg";